export default "__VITE_ASSET__LSUEMsNN__"